<ng-container *ngIf="isDesktopDevice; else smallDevice">
  <button mat-icon-button [matMenuTriggerFor]="userMenu">
    <app-avatar
      [image]="avatar"
      size="45"
      class="user__avatar clickeable"
    ></app-avatar>
  </button>

  <mat-menu #userMenu="matMenu">
    <button mat-menu-item (click)="selectApp()">
      <mat-icon>view_stream</mat-icon>
      <span>Select Site</span>
    </button>
    <button mat-menu-item routerLink="'/settings'">
      <mat-icon>settings</mat-icon>
      <span>Settings</span>
    </button>
    <button mat-menu-item (click)="logout()">
      <mat-icon>exit_to_app</mat-icon>
      <span>Logout</span>
    </button>
    <button mat-menu-item (click)="goToProfile()" disabled>
      <mat-icon>account_circle</mat-icon>
      <span>Profile</span>
    </button>
  </mat-menu>
</ng-container>

<ng-template #smallDevice>
  <button mat-menu-item (click)="selectApp()">
    <mat-icon>view_stream</mat-icon>
    <span>Select Site</span>
  </button>
  <button mat-menu-item routerLink="'/settings'">
    <mat-icon>settings</mat-icon>
    <span>Settings</span>
  </button>
  <button mat-menu-item (click)="logout()">
    <mat-icon>exit_to_app</mat-icon>
    <span>Logout</span>
  </button>
</ng-template>
